// extracted by mini-css-extract-plugin
export default {"c":"Home_c__ZN1jR","l":"Home_l__+IfWs"};